

export default function Divider(props) {

    return (
        <div style={{
            borderBottom: "1px solid var(--e-global-color-ce0cfb7)",
        }}>
        </div>
    )
}